import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Hashsum, PackageUpsaleOptionsStateType } from './types';

export const name = 'packageUpsaleOptions';

const initialState: PackageUpsaleOptionsStateType = {
  extraOptions: [],
  transferOptions: [],
  chosenOptions: [],
};

// Доп услуги на странице чекаута собранные из api
const packageUpsaleOptions = createSlice({
  name,
  initialState,
  reducers: {
    fetchSuccess(state, action: PayloadAction<PackageUpsaleOptionsStateType>) {
      state.extraOptions = action.payload.extraOptions;
      state.transferOptions = action.payload.transferOptions;
      state.insuranceOption = action.payload.insuranceOption;
    },
    fetchError(state) {
      state.extraOptions = [];
      state.transferOptions = [];
    },
    setOptions(state, action: PayloadAction<Hashsum>) {
      state.chosenOptions = [...state.chosenOptions, action.payload];
    },
    toggleInsurance: (state) => {
      const insuranceHashsum = state.insuranceOption?.options[0].hashsum;
      if (!insuranceHashsum) return;
      const idx = state.chosenOptions.findIndex(
        (hashsum) => hashsum === insuranceHashsum,
      );
      if (idx === -1)
        state.chosenOptions = [...state.chosenOptions, insuranceHashsum];
      else state.chosenOptions.splice(idx, 1);
    },
    toggleTransferRequest: (state) => {
      state.transferRequest = {
        isSelected: !state.transferRequest?.isSelected,
      };

      if (state.transferRequest.message && !state.transferRequest.isSelected)
        state.transferRequest.message = undefined;
    },
    saveTransferRequest: (state, action: PayloadAction<string>) => {
      if (state.transferRequest?.isSelected)
        state.transferRequest.message = action.payload;
    },
    clearOptions: () => initialState,
    uncheckOption: (state, action: PayloadAction<Hashsum>) => {
      const filteredChosenOptions = state.chosenOptions.filter(
        (hashsum) => hashsum !== action.payload,
      );
      state.chosenOptions = filteredChosenOptions;
    },
    // сбрасываем выбор страховки
    resetInsuranceSelection: (state) => {
      const insuranceHashsum = state.insuranceOption?.options[0].hashsum;
      if (!insuranceHashsum) return;

      state.chosenOptions = state.chosenOptions.filter(
        (hashsum) => hashsum !== insuranceHashsum,
      );
    },
  },
});

// export
export const {
  fetchSuccess,
  fetchError,
  setOptions,
  clearOptions,
  toggleInsurance,
  uncheckOption,
  toggleTransferRequest,
  saveTransferRequest,
  resetInsuranceSelection,
} = packageUpsaleOptions.actions;
export default packageUpsaleOptions.reducer;
